export var formatApiResponseToAddress = function formatApiResponseToAddress(responses, questionAlias) {
  var formattedResponses = {};
  Object.keys(responses).map(function (key) {
    var alias = key.replace(questionAlias + '_', '');
    formattedResponses[alias] = responses[key];
    return true;
  });
  return formattedResponses;
};
export default {
  formatApiResponseToAddress: formatApiResponseToAddress
};